import angular from 'angular';
import _ from 'lodash';
import categoriesModalTemplate from './categories.modal.html';


class ProfileRegistryController {
  /* @ngInject */
  constructor($log, $q, $scope, $rootScope, NewBackendService, endPoints, LoginService, StorageService, MerchantConfigurationService, ImageUtilsService, FoundationApi, $element, MerchantDetailService, NewTokenService, CategoriesService, ModalFactory, $timeout) {
    const OK_STATUS_CODE = '000';
    const that = this;

    this.isSuperAdmin = StorageService.getLocalStorage('superAdmin');
    this.myCroppedImage = '';
    this.errorImage = '';
    this.isLoadingImage = false;
    this.userProfile = {};
    this.profileObj = {
      avatarImage: '',
      coverImage: '',
      isCrop: false,
      position: false
    };

    this.addressModal = false;

    this.openAddressModal = () => {
      that.addressModal = true;
    };

    this.closeAddressModal = () => {
      that.addressModal = false;
    };

    this.contactsBackup = undefined;

    this.loading = {
      contacts: false,
      details: false
    };

    this.resetModal = () => {
      that.profileObj.isCrop = false;
      that.myCroppedImage = '';
      that.profileObj.avatarImage = '';
      document.getElementById('avatar').src = '';
      FoundationApi.closeActiveElements();
    };

    this.resizeImage = () => {
      that.profileObj.isCrop = false;
      that.contacts.image = that.myCroppedCover;
      that.errorImage = '';
    };

    this.uploadImage = () => {
      if (that.myCroppedImage === '') {
        return;
      }
      var sendImage = that.myCroppedImage;
      let request = [{"op": "replace", "path": "/avatarImage", "value": that.myCroppedImage.replace("data:image/png;base64,", "")}] 
      NewBackendService.invokeWebApiPatch(`${endPoints.userUrl}/users/${that.userProfile.id}/businesses/${that.userProfile.business.id}`, request, false).then(result => {
          that.userProfile.avatar = sendImage;
          $rootScope.$broadcast('AVATAR_CHANGE', sendImage);
          }, (error) => {
            $log.error(error);
          });
          FoundationApi.closeActiveElements();
          that.profileObj.avatarImage = '';
          that.myCroppedImage = '';
          document.getElementById('avatar').src = '';
        }
     

    this.loadQrCode = (businessId) =>{
      NewBackendService.invokeWebApiGet(`${endPoints.userUrl}/businesses/me/admin/qrcode/${businessId}/BUSINESS`).then(res => {
        let pdfWindow = window.open("")
         pdfWindow.document.write("<iframe width='100%' height='100%' src='data:application/pdf;base64,"+res.data.pdf+"'></iframe>")
      }, reason => {
        $log.error(reason);
      })
    };


    const loadUserProfile = () => {
        this.loading.contacts = true;
        var merchantProfile = JSON.parse(StorageService.getLocalStorage('userContext'));
        that.userProfile = merchantProfile;
        var address = merchantProfile.business.addresses.find(el => el.type == "LEG")
        if(address){
          this.userProfile.indirizzo = address.street+" "+address.streetNumber+" - "+address.city
        }
    };

    const handleFileSelect = (evt) => {
      if (evt.files === null) return;
      const file = evt.files[0];
      if (file.size > 4194304) {
        that.errorImage = 'Dimensione massima di caricamento 4MB';
        return;
      } else if (/gif/.test(file.type)) {
        that.errorImage = 'Estensione consentita PNG - JPG';
        return;
      }
      that.profileObj.isCrop = true;
      const reader = new FileReader();
      reader.onload = (evnt) => {
        $scope.$apply(() => {
          if (evt.id === 'fileCover') {
            that.profileObj.coverImage = evnt.target.result;
          } else {
            that.profileObj.avatarImage = evnt.target.result;
          }
        });
      };
      reader.readAsDataURL(file);
    };

  
    this.saveMerchantDetails = () => {
      that.loading.details = true;
      MerchantDetailService.changeBusinessData(that.userProfile.business.id, that.userProfile.business).finally(() => {
        StorageService.setLocalStorage('userContext', JSON.stringify(that.userProfile));
        $rootScope.$broadcast('BANNER_CHANGE', that.userProfile.business.company);
        that.loading.details = false;
      });
    };

    this.resetMerchantDetails = () => {
      that.userProfile.intestazione = that.backupIntestazione;
    };


    const init = () => {
      loadUserProfile();
      $element.on('change', (e) => {
        handleFileSelect(e.target);
      });
      /*if (that.isSuperAdmin) {
        loadQrCode();
      }*/
    };

    that.$onInit = init;

    that.resetMerchantContacts = loadUserProfile;
  }
}

export default ProfileRegistryController;



/** WEBPACK FOOTER **
 ** ./client/app/components/profile/registry/registry.controller.js
 **/